export const brandNames = {
  vw: 'Volkswagen',
  vwfs: 'Volkswagen',
  vwcv: 'Volkswagen',
  skoda: 'SKODA',
  seat: 'SEAT',
  audi: 'AUDI',
}
